import HorizontalScroller from "components/common/HorizontalScroller";
import InfoItem from "components/common/detailsPage/InfoItem";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import QRCodeCard from "components/common/QRCodeCard";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getQrLinkDetails } from "store/slices/qrLinksSlice";
import { formatUTCDate } from "utils/utils";
import { Images } from "assets/images";
import PageHeader from "components/common/PageHeader";

const QRLinkDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("qr_links");
  const { loading, itemDetails } = useSelector((state) => state.QRLinks);
  const { logo } = Images || {};

  useEffect(() => {
    if (id && canView) dispatch(getQrLinkDetails(id));
  }, [id, canView, dispatch]);

  if (!canView) return null;

  if (loading) {
    return (
      <div className="page-content common_details_page qr_link_details_page">
        <PageHeader
          title={t("QR Link Details")}
          isBackBtn
          className="details_page_title"
        />
        <DetailsShimmer />
      </div>
    );
  }

  const qrValue =
    process.env.REACT_APP_QR_CODE_LINK && itemDetails?.identifierCode
      ? `${process.env.REACT_APP_QR_CODE_LINK}${itemDetails.identifierCode}`
      : "";

  return (
    <div className="page-content common_details_page qr_link_details_page">
      <PageHeader
        title={t("QR Link Details")}
        isBackBtn
        className="details_page_title"
      />
      <Row>
        <Col lg={7} md={9}>
          <div className="common_card h-100">
            <h2 className="title_20">{t("QR Link Information")}</h2>
            <div className="general_details_wrapper">
              <Row id="general_detail_row">
                <InfoItem label={t("ID")} col={{ lg: 6, xs: 12 }}>
                  <HorizontalScroller>
                    {itemDetails?._id || "-"}
                  </HorizontalScroller>
                </InfoItem>
                <InfoItem
                  label={t("Label")}
                  value={itemDetails?.label || "-"}
                  col={{ lg: 6, xs: 12 }}
                />
                <div className="mt-4 w-100" />
                <InfoItem
                  label={t("QR Identifier")}
                  value={itemDetails?.identifierCode || "-"}
                  col={{ lg: 6, xs: 12 }}
                />
                <InfoItem
                  label={t("Location Name")}
                  value={itemDetails?.dynamicParams?.locationName || "-"}
                  col={{ lg: 6, xs: 12 }}
                />
                <div className="mt-4 w-100" />
                <InfoItem
                  label={t("Fallback URL")}
                  value={itemDetails?.fallbackUrl || "-"}
                  col={{ lg: 12, xs: 12 }}
                />
                <div className="mt-4 w-100" />
                <InfoItem
                  label={t("Created At")}
                  value={formatUTCDate(itemDetails?.createdAt) || "-"}
                  col={{ lg: 6, xs: 12 }}
                />
                <InfoItem
                  label={t("Updated At")}
                  value={formatUTCDate(itemDetails?.updatedAt) || "-"}
                  col={{ lg: 6, xs: 12 }}
                />
              </Row>
            </div>
          </div>
        </Col>

        {qrValue && (
          <Col lg={5} md={9}>
            <div className="common_card h-100">
              <h2 className="title_20">{t("QR Code")}</h2>
              <QRCodeCard
                value={qrValue}
                fileName={itemDetails?.label || "qr-code"}
                image={logo}
                style={itemDetails?.qrStyle}
                fromQRDetails={true}
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default QRLinkDetails;
